import { object, string } from "yup";

export const opsBulkActionSchema = object({
  value: string().required(),
});
